<template>
  <div class="main">
    <AppHeader />
    <div class="detail">
      <div class="content">
        <span class="breadcrumb">
          <span @click="toHome()">教研新空间</span> > 详情
        </span>
        <el-divider></el-divider>
        <div class="content-show">
          <div class="resource-display">
            <media-resource :preview="preview" :rid="rid" :res-info="resInfo"></media-resource>
          </div>
          <!-- <div class="resource-introduced">
            <introduction ref="introductRef" :res-info="resInfo"></introduction>
          </div> -->
        </div>
      </div>
      <div class="comment">
        <div class="remarks">
          <p class="remarks-title"><span></span>评论</p>
          <el-divider></el-divider>
          <!-- <div class="rate">
              <span class="title">{{ rateValueCopy ? '您已评价' : '评价资源' }} :  </span>
              <el-rate
                v-model="rateValue"
                :texts="rateTexts"
                :disabled="rateValue ? true : false"
                @change="changeRate"
                show-text>
              </el-rate>
            </div> -->
          <div class="self-remarks">
            <p class="title">您的评论</p>
            <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="selfRemarks">
            </el-input>
            <p class="operation">
              <el-button type="primary" class="submit-remarks" @click="toReply">
                提交评论
              </el-button>
            </p>
          </div>
          <div class="user-remarks">
            <p class="title">
              用户评论<span>({{ page.total }})</span>
            </p>
            <template v-if="remarksList && remarksList.length">
              <remarks-item v-for="(item, index) in remarksList" :key="index" :item-info="item" @add-remark="addRemark" @update="getRemarksList">
              </remarks-item>
            </template>
            <div v-else class="no-data">
              <img :src="require('@/assets/img/empty.png')" />
              <p>暂无数据</p>
            </div>
          </div>
          <!-- 分页 -->
          <div v-if="remarksList && remarksList.length" class="page-block">
            <el-pagination @current-change="handleCurrentChange" :current-page="page.currentPage" :page-size="page.pageSize" layout="total, prev, pager, next, jumper" :total="page.total" />
          </div>
          <!-- 分页 -->
        </div>
        <!-- <div class="recommend">
            <p class="remarks-title"><span></span>资源推荐</p>
            <el-divider></el-divider>
              <template v-for="(item, index) in resourceList">
                <recommend-item :key="index" :item-info="item" />
              </template>
          </div> -->
      </div>
    </div>
    <!-- <AppFoot /> -->
    <AppFoot showCopyRight showLink :showContect="false" />
  </div>
</template>

<script>
import MediaResource from "./components/media-resource.vue";
import Introduction from "./components/introduction.vue";
import RemarksItem from "./components/remarks-item.vue";
// import RecommendItem from "./components/recommend-item.vue"
import { mapState } from "vuex";

const {
  VUE_APP_APPNAME,
  VUE_APP_APPKEY,
  VUE_APP_SSOSERVERURL,
  VUE_APP_LOGINREDIRECTURL
} = process.env

export default {
  components: {
    MediaResource,
    Introduction,
    RemarksItem,
    // RecommendItem,
  },
  data() {
    return {
      signVisible: false,
      rateValue: 0,
      rateValueCopy: 0,
      rateTexts: ["很差", "较差", "还行", "推荐", "力荐"],
      selfRemarks: "",
      preview: {
        ext: "initial",
        preview_url: "",
        fileType: "",
      },
      resInfo: {},
      rid: "",
      remarksList: [],
      resourceList: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: 10,
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    next();
  },
  created() {
    this.rid = this.$route.query.detailId;
    this.getDetailInfo();
    this.getRemarksList();
  },
  computed: {
    localComputed() { },
    ...mapState({
      loginStatus: (state) => state.loginStatus.valueOf(),
    }),
  },
  methods: {
    async getDetailInfo() {
      try {
        let { data } = await this.$api.res.getResource({
          resourceId: this.rid,
        });
         
        this.resInfo = data;
        this.preview.preview_url = data.previewUrl.replace('http://', 'https://');
       // this.preview.preview_url = data.previewUrl;
        // }
      } catch (error) {
        console.log(error);
      }
    },
    toReply() {

      // SSO配置
      window.SSO.appName = VUE_APP_APPNAME
      window.SSO.appKey = VUE_APP_APPKEY
      window.SSO.SSOServerUrl = VUE_APP_SSOSERVERURL
      window.SSO.loginRedirectUrl = VUE_APP_LOGINREDIRECTURL
      // 登录状态
      window.SSO.getLoginState((res) => {
        console.log(res)
        const isLogin = res.code === 1001
        if (isLogin) {
          window.localStorage.setItem('st', res.data.st)
          window.localStorage.setItem('tgt', res.data.tgt)
          if (this.selfRemarks.trim().length < 1) {
            this.$message.warning('请输入评论内容')
            return
          }
          let params = {
            resourceId: this.rid,
            content: this.selfRemarks.trim(),
            toCommentId: "",
          }
          this.addRemark(params);
        } else {
          this.$confirm('登录之后才能评论，请先登录', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            window.open(VUE_APP_LOGINREDIRECTURL, "_blank");
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
          
        }
      })

      // let code = 0;
      // window.SSO.client = "web";
      // //TODO 根据实际应用使用的appKey标识填写
      // window.SSO.mac = window.SSO.deviceId;
      // window.SSO.customLogoutUrl = "";
      // window.SSO.needAttribute = true;
      // window.SSO.SSOServerUrl = process.env.VUE_APP_SSO_URL;
      // window.SSO.SSOCenterServerUrl = process.env.VUE_APP_SSO_URL;
      // window.SSO.loginRedirectUrl = "";
      // window.SSO.isCenterSSO = true;
      // window.SSO.accountTypeIsAuto = true;
      // window.SSO.needToken = true;
      // window.SSO.appKey = "8a1061d2a87344dd87e3b6e8ed10ac32";
      // // 获取token 和id
      // window.SSO.getAccessToken((res) => {
      //   console.log(res);
      //   if (res.code === '1') {
      //     if (this.selfRemarks.trim().length < 1) {
      //       this.$message.warning('请输入评论内容')
      //       return
      //     }
      //     let params = {
      //       resourceId: this.rid,
      //       content: this.selfRemarks.trim(),
      //       toCommentId: "",
      //     }
      //     // localStorage.setItem('token', res.data.token);
      //     // localStorage.setItem('clientType', window.APP_CONFIG.clientType); // 配置文件
      //     // localStorage.setItem('deviceId', SSO.deviceId);
      //     // localStorage.setItem('appKey',  window.APP_CONFIG.appKey); // 配置文件
      //     this.addRemark(params);
      //   } else {
      //     window.open(process.env.VUE_APP_LOGIN_URL, '_blank');
      //   }
      // });
    },
    async addRemark(param) {
      try {
        const { code } = await this.$api.res.addComment(param);
        if (code == '1') {
          this.selfRemarks = '';
          this.handleCurrentChange(1);
          this.$message.success('评论成功')
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    async getRemarksList() {
      try {
        const { data } = await this.$api.res.listComment({
          resourceId: this.rid,
          pageNum: this.page.currentPage,
          pageSize: this.page.pageSize
        });
        this.page.total = parseInt(data.totalSize || 0);
        this.remarksList = data.rows;
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getRemarksList();
    },
    async changeRate(value) {
      if (!this.isLogin()) {
        // todo 去登录页
        this.$message.error("请登录");
        return;
      }
      try {
        const { data, code, message } = await this.$api.detail.addScore({
          resId: this.rid,
          score: value,
        });
        alert(message);
        window.location.reload();
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    isLogin() {
      return this.loginStatus;
    },
    toHome() {
      this.$router.push({ name: "home" });
    },
    cancelLogin(val) {
      if (!this.rateValueCopy) {
        this.rateValue = 0;
      }
    },
  },
};
</script>

<style scoped lang="less">
.main {
  background-color: #f4f5f7;
  .detail {
    width: 1215px;
    margin: auto;
    & > * {
      background-color: #ffffff;
      margin: 10px 0;
      padding: 15px;
      border-radius: 5px;
    }
    .content {
      // height: 400px;
      .breadcrumb {
        font-size: 14px;
        color: #606266;
        span:hover {
          color: #409eff;
          cursor: pointer;
        }
      }
      .el-divider--horizontal {
        margin: 15px 0;
      }
      .el-divider {
        background-color: #f0f0f0;
      }
      .content-show {
        // height: 800px;
        display: flex;
        .resource-display {
          flex: 1;
        }
        .resource-introduced {
          width: 30%;
        }
      }
    }
    .comment {
      // height: 600px; 不设具体宽高, 但是会出现父元素高度塌陷, 因为子元素左右浮动.
      // 要清除浮动.
      overflow: auto;
      & > * {
        // height: 100%;
        box-sizing: border-box;
      }
      .remarks-title {
        font-size: 16px;
        span {
          position: relative;
          top: 1px;
          display: inline-block;
          width: 6px;
          height: 15px;
          margin-right: 10px;
          background: #409eff;
          border-radius: 2px;
        }
      }
      .remarks {
        float: left;
        position: relative;
        width: 100%;
        padding-right: 10px;
        &::after {
          content: '';
          width: 1px;
          position: absolute;
          right: 0;
          top: 0;
          height: 100%;
          background-color: #f0f0f0;
        }
        .rate {
          display: flex;
          .title {
            color: #8a8a8a;
            margin-right: 3px;
          }
        }
        .self-remarks {
          overflow: auto;
          .title {
            color: #8a8a8a;
          }
          .operation {
            float: right;
            .login {
              cursor: pointer;
            }
            .register {
              cursor: pointer;
            }
            .submit-remarks {
              margin-left: 10px;
            }
          }
          // &::after { 清除浮动的方法 1.self-remarks加上overflow: auto; 2.用伪元素
          //   content: '';
          //   display: block;
          //   clear: both;
          // }
        }
        .user-remarks {
          min-height: 250px;
          .title {
            color: #8a8a8a;
          }
          .no-data {
            text-align: center;
            p {
              color: #ccc;
            }
          }
        }
        .page-block {
          float: right;
          padding-top: 10px;
        }
      }
      .el-textarea {
        margin: 20px 0;
      }
      .recommend {
        float: right;
        width: 25%;
        padding-left: 10px;
      }
    }
  }
}
</style>
